module.exports = __webpack_public_path__ + "img/5.d1dd2e96.jpg";